import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api";
import { Status } from "../../../common/constants";
import { signOutUrl } from "../../../config";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const SIGN_OUT_USER: string = "signOutUser";

const initialState: IInitialSliceState = {
    msg: null,
    status: Status.IDLE,
    error: null,
};

interface ISignOutDetailsResponse {
    message: string;
}

export const signOut = createAsyncThunk(SIGN_OUT_USER, async () => {
    try {
        const signOutDetailsResponse = await api.post<ISignOutDetailsResponse>(`${signOutUrl}`,
            {},
            {
                headers: {
                    "Content-Type":"application/json",
                },
                withCredentials:true,
            });
        return signOutDetailsResponse.data;
    } catch (error: any) {
        throw error;
    }
});

const signOutSlice = createSlice({
    name: SIGN_OUT_USER,
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(signOut.pending, (state) => {
                state.status = Status.PENDING;
            })
            .addCase(signOut.fulfilled, (state, action) => {
                state.status = Status.SUCCESS;
                state.msg = action.payload?.message ?? null;
            })
            .addCase(signOut.rejected, (state, action) => {
                state.status = Status.FAILED;
                state.error = action.error.message;
            })
    },
});

type Selector = {
    signOutApi: ReturnType<
        typeof signOutSlice.reducer
    >;
};

export const selector = (store: Selector) => store['signOutApi'];
export default signOutSlice.reducer;